import Typewriter from 'typewriter-effect';
import Contact from './Contact';
import Education from './Education';
import Work from './Work';
import SocialLinks from './SocialLinks';
import DownloadCV from './DownloadCV';
import { useState, useEffect, useRef } from 'react';
import Coder from './Coder';
import FloatingParticles from './FloatingParticles';
import useScrollReveal from '../hooks/useScrollReveal';

const MainContainer = ({ about, work, education, contact }) => {
    const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrolled = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
            setScrollProgress(scrolled);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollHandler = (elementRef) => {
        window.scrollTo({ top: elementRef.current.offsetTop, behavior: "smooth" });
    };

    const workRevealRef = useRef(null);
    const educationRevealRef = useRef(null);
    const contactRevealRef = useRef(null);

    useScrollReveal(workRevealRef);
    useScrollReveal(educationRevealRef);
    useScrollReveal(contactRevealRef);

    return (
        <div className="w-full h-full min-h-screen bg-black text-white overflow-x-hidden font-nunito">
            { /* Progress Bar */}
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: `${scrollProgress}%`,
                    height: '3px',
                    background: 'linear-gradient(90deg, #a855f7, #ff0080)',
                    zIndex: 50,
                    transition: 'width 0.1s smooth'
                }}
            />
            <div className="fixed inset-0 z-0 pointer-events-none">
                <FloatingParticles />
            </div>
            <div ref={about} className="relative z-10 w-full mb-[-5%]">
                <img
                    className="w-full h-full absolute object-cover opacity-20"
                    style={{ opacity: 0.3 }}
                    src="assets/profile-bg.jpg"
                    alt="profile-bg"
                />

                <div className="container1 w-full">
                    <div className="w-full sm:justify-center sm:items-center py-12 sm:py-8">
                        { /* Cover Photo Section */}
                        <div className="relative w-full h-40 sm:h-40 md:h-48 bg-[#001f3f]">
                            <div class="absolute inset-0 bg-gradient-to-b from-black to-transparent"></div>
                            <img
                                src="assets/work-bg.jpg"
                                alt="cover"
                                className="w-full h-full object-cover"
                                style={{ backgroundColor: "#001f3f" }}
                            />
                            {/* Profile photo positioned at the middle bottom of cover */}
                            <div className="absolute left-1/2 bottom-0 translate-x-[-50%] translate-y-1/2">
                                <img
                                    width={120}
                                    height={80}
                                    src="/assets/profile-photo.jpg"
                                    alt="profile"
                                    className="border-4 border-white rounded-full shadow-lg"
                                />
                            </div>
                        </div>
                        <div className="text-center mt-[22%] pb-4 md:mt-[12%] lg:mt-[12%] md:ml-[2%] lg:ml-[2%]">
                            <h1>Hello & Welcome</h1>
                            <div className="flex justify-center items-center flex-wrap">
                                <h1 className="text-white text-4xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl py-2 px-3">{"I Am"}</h1>
                                <h1 className="text-4xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl py-2 font-bold text-[#61dafb]">
                                    <Typewriter onInit={(typewriter) => {
                                        typewriter.typeString("Krishnendu.")
                                            .pauseFor(1000)
                                            .deleteAll()
                                            .typeString("A Software Developer.")
                                            .pauseFor(1000).deleteAll().typeString("Krishnendu.")
                                            .start();
                                    }} />
                                </h1>
                            </div>
                            <div className="text-lg">
                                <h1 className="slidein 1s ease 500ms forwards">I am a Full Stack Developer</h1>
                                <h1>I develop web applications in .NET & React</h1>
                                <SocialLinks />
                            </div>
                            <DownloadCV />
                        </div>
                    </div>
                    <div className="backdrop-filter backdrop-blur-2xl w-full md:w-full lg:w-full md:ml-0 lg:ml-0 md:pt-[7.5%] lg:pt-[7%] md:pl-[3%] lg:pl-[3%] pr-[2%] pl-[5%] sm:pl-[3%]">
                        <Coder />
                    </div>
                </div>
            </div>
            <div ref={(el) => { work.current = el; workRevealRef.current = el; }} className="w-full scroll-reveal relative z-10">
                <Work />
            </div>
            <div ref={(el) => { education.current = el; educationRevealRef.current = el; }} className="w-full scroll-reveal relative z-10">
                <Education />
            </div>
            <div ref={(el) => { contact.current = el; contactRevealRef.current = el; }} className="w-full scroll-reveal relative z-10">
                <Contact />
            </div>
        </div>
    );
};

export default MainContainer;